import { scrollChatToBottom } from "../pages/chats.js";
import { byCssClass } from "../common/dom-util.js";

const Layout = {
  details: "split_layout__details",
  list: "split_layout__list",
  open: "open",
  closed: "closed",
};

/**
 * For the form record page, when the screen is small: shows the form record data in the east layout,
 * and hides the center layout with the list of form records.
 */
export function openDetailsPanel() {
  const detailsContainer = byCssClass(Layout.details);
  const listContainer = byCssClass(Layout.list);
  if (detailsContainer !== undefined && listContainer !== undefined) {
    detailsContainer.classList.add(Layout.open);
    listContainer.classList.remove(Layout.open);
    detailsContainer.classList.remove(Layout.closed);
    listContainer.classList.add(Layout.closed);
  }
  if (PF) {
    const editor = PF("messageEditor");
    if (editor instanceof PrimeFaces.widget.DeferredWidget) {
      editor.renderDeferred();
    }
  }
  scrollChatToBottom();
}

/**
 * For the form record page, when the screen is large: hides the form record data in the east layout,
 * and shows the center layout with the list of form records.
 */
export function closeDetailsPanel() {
  const detailsContainer = byCssClass(Layout.details);
  const listContainer = byCssClass(Layout.list);
  if (detailsContainer !== undefined && listContainer !== undefined) {
    listContainer.classList.add(Layout.open);
    detailsContainer.classList.remove(Layout.open);
    detailsContainer.classList.add(Layout.closed);
    listContainer.classList.remove(Layout.closed);
  }
}

/**
 * Checks if the current screen is a small breakpoint view.
 * @returns {boolean} `true` if the screen is a small breakpoint view; `false` otherwise.
 */
export function isSmallBreakpointView() {
  return window.matchMedia("(max-width: 580px)").matches;
}
